export var GlobalNotificationType;
(function (GlobalNotificationType) {
    GlobalNotificationType["CRITICAL"] = "danger";
    GlobalNotificationType["IMPORTANT"] = "warning";
    GlobalNotificationType["GENERAL"] = "info";
})(GlobalNotificationType || (GlobalNotificationType = {}));
export var GlobalNotificationSubjects;
(function (GlobalNotificationSubjects) {
    GlobalNotificationSubjects["Notification"] = "global-notification";
})(GlobalNotificationSubjects || (GlobalNotificationSubjects = {}));
//# sourceMappingURL=global-notifications.enum.js.map